import { z } from 'zod';
import { boundedText, maxCodePoints } from '@/lib/forms/primitives';

/**
 * DRBFM → verification convert wizard, new-unit fields shared by both target branches.
 *
 * A module-level const, not a `createSchema(t)` factory: messages resolve
 * lazily at parse time, so this stays stable across language changes.
 *
 * CAPS ARE DB MIRRORS, not product choices —
 *   database/migrations/019_verification_tables.sql:9   title       VARCHAR(500)
 *   database/migrations/019_verification_tables.sql:10  model_name  VARCHAR(200)
 *   database/migrations/019_verification_tables.sql:20  unit_number VARCHAR(20)
 *   database/migrations/019_verification_tables.sql:21  unit_name   VARCHAR(200)
 * The wizard seeds both the title and the unit name from drbfmItemName, itself capped at
 * 500, so a long but legal item name overflows unit_name VARCHAR(200) with zero typing.
 *
 * Unit number/name are required whenever a new unit is created. This prevents cleared
 * inputs from silently falling back to stale/default values during conversion.
 */
export const newVerificationUnitSchema = z.object({
  newUnitNumber: boundedText(20, 'validation.required', 'validation.maxLength'),
  newUnitName: boundedText(200, 'validation.required', 'validation.maxLength'),
});

export const convertToVerificationSchema = newVerificationUnitSchema.extend({
  newSessionTitle: boundedText(500, 'validation.required', 'validation.maxLength'),
  newSessionModelName: z.string().check(maxCodePoints(200, 'validation.maxLength')),
});
